import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const DEFAULT_TITLE = 'Confirm Action';
const DEFAULT_MESSAGE = 'Are you sure you want to proceed?';
const DEFAULT_CLOSE = 'Close';
const DEFAULT_CONFIRM = 'Continue';

const ConfirmationModal = (props) => {
	return (
		<Modal show={props.isDisplayed} onHide={() => props.handleModalClose(false)}>
			<Modal.Header closeButton>
				<Modal.Title>{props.title || DEFAULT_TITLE}</Modal.Title>
			</Modal.Header>
			<Modal.Body>{props.message || DEFAULT_MESSAGE}</Modal.Body>
			<Modal.Footer>
				<Button variant="secondary" onClick={() => props.handleModalClose(false)}>
					{props.closeButton || DEFAULT_CLOSE}
				</Button>
				<Button id="btnConfirmationModalSubmit" variant="primary" onClick={() => props.handleModalClose(true)}>
					{props.confirmButton || DEFAULT_CONFIRM}
				</Button>
			</Modal.Footer>
		</Modal>
	);
}

export default ConfirmationModal;